/* Fiche produit — deux corrections de disposition qui ne se font pas en CSS.

   1. Le guide des tailles vivait sur sa propre ligne, sous le selecteur. Il se
      lit au moment ou l on choisit la taille : il remonte donc SUR la ligne du
      libelle « Size », a droite (retour user du 17/09).
   2. Le selecteur se re-rend a chaque changement de variante : sans
      observateur, le guide retombe a sa place d origine au premier clic. */
(function () {
  /* 05/10 : textes en anglais en dur -> lus dans #lv-i18n (rendu traduit par le selecteur). */
  function T(k, def) {
    try { return JSON.parse(document.getElementById('lv-i18n').textContent)[k] || def; } catch (e) { return def; }
  }
  /* 05/10 : le guide etait deplace DANS le selecteur ; au changement de taille le selecteur
     se re-rend et le guide disparaissait. On garde la reference au noeud pour le remettre. */
  var lvGuide = null;
  function poser() {
    var picker = document.querySelector('.variant-picker');
    var guide = lvGuide || document.querySelector('.lauven-guide');
    if (guide) lvGuide = guide;
    if (!picker || !guide) return;

    /* Deux essais rates avant celui-ci (mesures du 17/09) :
       - glisser le guide a cote du libelle poussait le XL a la ligne, parce que
         le parent du libelle est la RANGEE des boutons de taille ;
       - creer une ligne d en-tete dans ce meme parent la rendait elle-meme
         boutonnee, en travers des tailles.
       On ne touche donc plus a la rangee : le guide devient enfant du picker et
       se pose en absolu sur la ligne du libelle (CSS `.variant-picker`). */
    if (guide.parentElement === picker) return;
    picker.appendChild(guide);
  }

  /* Rarete honnete : on n affiche un message que si le stock REEL de la
     variante choisie est bas. 3 et moins — au-dessus, un compteur ne dit rien
     de vrai et ressemble a une ficelle. */
  function stock() {
    var boite = document.querySelector('[data-lv-stocks]');
    var ligne = document.querySelector('.lv-stock');
    if (!boite || !ligne) return;
    var stocks;
    try { stocks = JSON.parse(boite.textContent); } catch (e) { return; }
    var champ = document.querySelector('.variant-picker input:checked, [name="id"]');
    var id = null;
    if (champ) id = champ.value || champ.getAttribute('data-variant-id');
    if (!id) {
      var url = new URL(location.href);
      id = url.searchParams.get('variant');
    }
    var q = id ? stocks[id] : null;
    if (typeof q === 'number' && q > 0 && q <= 3) {
      ligne.textContent = q === 1 ? T('stock_last', 'Last one in this size') : T('stock_few', 'Only {n} left in this size').replace('{n}', q);
      ligne.hidden = false;
    } else {
      ligne.hidden = true;
    }
  }

  /* Liste d attente : une option indisponible porte `data-option-available`
     a `false`. Un clic dessus ouvre le formulaire avec la taille pre-remplie. */
  function attente() {
    var boite = document.querySelector('.lv-attente');
    if (!boite) return;
    document.addEventListener('click', function (ev) {
      var lab = ev.target.closest && ev.target.closest('label, .variant-option__button-label');
      if (!lab) return;
      var id = lab.getAttribute('for');
      var input = id ? document.getElementById(id) : lab.querySelector('input[type="radio"]');
      if (!input) input = lab.previousElementSibling;
      if (!input || input.dataset.optionAvailable !== 'false') {
        boite.hidden = true;
        return;
      }
      var taille = input.value || lab.textContent.trim();
      var t = boite.querySelector('[data-lv-attente-titre]');
      if (t) t.textContent = T('size_oos', 'Size {size} is out of stock').replace('{size}', taille);
      var champ = boite.querySelector('[data-lv-attente-taille]');
      if (champ) champ.value = taille;
      var corps = boite.querySelector('[data-lv-attente-corps]');
      if (corps) corps.value = 'Back in stock request — size ' + taille + ' — ' + location.href;
      boite.hidden = false;
    }, { passive: true });
  }

  /* Sur une fiche a 24 coloris, les vignettes font 518 px de haut et repoussent
     le bouton d achat d autant (mesure du 17/09, seraphina-maxi-dress-15). On
     n en montre que DEUX rangees, le reste derriere un bouton. */
  function couleurs() {
    document.querySelectorAll('.variant-option--swatches').forEach(function (champ) {
      if (champ.dataset.lvPlie) return;
      var vignettes = champ.querySelectorAll('.swatch');
      if (vignettes.length <= 10) return;
      champ.dataset.lvPlie = '1';
      champ.classList.add('lv-couleurs--pliees');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lv-couleurs__plus';
      b.textContent = T('colours_all', 'Show all {n} colours').replace('{n}', vignettes.length);
      b.addEventListener('click', function () {
        var ouvert = champ.classList.toggle('lv-couleurs--ouvertes');
        b.textContent = ouvert ? T('colours_less', 'Show fewer colours') : T('colours_all', 'Show all {n} colours').replace('{n}', vignettes.length);
      });
      champ.appendChild(b);
    });
  }

  /* 22/10 : la barre collante mobile est forcee visible des l arrivee (CSS 05/10).
     Le vrai bouton est remonte au-dessus du pli -> deux boutons a l ecran (retour user).
     On marque la barre quand le vrai bouton est visible a 60 % ; le CSS la cache alors. */
  var lvAtc = null, lvIo = null;
  function barre() {
    var sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky || !('IntersectionObserver' in window)) return;
    var atc = Array.prototype.find.call(document.querySelectorAll('button[name="add"]'), function (b) { return !b.closest('sticky-add-to-cart'); });
    if (!atc || atc === lvAtc) return;
    if (lvIo) lvIo.disconnect();
    lvAtc = atc;
    lvIo = new IntersectionObserver(function (e) {
      sticky.setAttribute('data-lv-atc-visible', e[0].intersectionRatio >= 0.6 ? 'true' : 'false');
    }, { threshold: [0, 0.6, 1] });
    lvIo.observe(atc);
  }

  /* 22/10 : bandeau cookies Pandectes = 235 px sur 844 en mobile (titre + prix caches).
     Il vit dans un shadow DOM sans « part » : la CSS du theme ne l atteint pas, on y pose
     un style compact (titre retire, texte garde, 2 boutons cote a cote, meme poids). */
  var LV_CK = '@media (max-width:749px){' +
    '.dialog.bar .header{display:none!important}' +
    '.dialog.bar .body{padding:12px 16px 0!important}' +
    '.dialog.bar .message{font-size:12px!important;line-height:1.4!important}' +
    '.dialog.bar .actions{display:flex!important;flex-direction:row!important;gap:8px!important;padding:10px 16px 12px!important}' +
    '.dialog.bar .actions button{flex:1 1 0!important;width:auto!important;margin:0!important;min-height:38px!important;padding:8px 10px!important}}';
  function cookies(n) {
    var h = document.querySelector('pandectes-cmp');
    var sr = h && h.shadowRoot;
    if (sr && !sr.getElementById('lv-ck')) {
      var s = document.createElement('style'); s.id = 'lv-ck'; s.textContent = LV_CK; sr.appendChild(s);
    }
    if ((n || 0) < 40) setTimeout(function () { cookies((n || 0) + 1); }, 500);
  }

  /* 22/10 : pas d indice « glisser » sur les cartes d un carrousel de produits (le glisser y fait
     defiler les produits). On marque la section comme « deja vue » pour l indice de product-card.js. */
  function carrousels() {
    var page = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') || '/';
    document.querySelectorAll('.resource-list__carousel').forEach(function (c) {
      var s = c.closest('.shopify-section');
      if (s) { try { sessionStorage.setItem('lauven_swipe_hint_vu:' + page + ':' + s.id, '1'); } catch (e) {} }
    });
  }

  function demarrer() {
    cookies();
    carrousels();
    /* 29/10 (vitesse) : hors fiche produit, rien de ce qui suit n a de cible (guide, stock,
       liste d attente, barre collante, couleurs pliees = CSS borne a [id$='__main']).
       Avant : deux observateurs sur tout le document, sur chaque page (~0,7 s mesure). */
    if (!document.querySelector("[id$='__main'] .variant-picker, [data-lv-stocks], .lv-attente, sticky-add-to-cart")) return;
    attente();
    couleurs();
    poser();
    stock();
    document.addEventListener('change', stock, { passive: true });
    document.addEventListener('click', function () { setTimeout(stock, 250); }, { passive: true });
    /* le picker se re-rend au changement de variante et au rendu de section :
       un seul observateur, regroupe a l image suivante (avant : deux, a chaque mutation) */
    barre();
    var lvPlan = 0;
    new MutationObserver(function () {
      if (lvPlan) return;
      lvPlan = requestAnimationFrame(function () {
        lvPlan = 0;
        couleurs();
        poser();
        barre();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
